import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 19v2h16v-14l-8 -4l-8 4v2","key":"svg-0"}],["path",{"d":"M13 14h-9","key":"svg-1"}],["path",{"d":"M7 11l-3 3l3 3","key":"svg-2"}]]

const IconTransferOut = createReactComponent('outline', 'transfer-out', 'TransferOut', __iconNode);

export default IconTransferOut;